import { FC } from 'react';
import { Button, Col, Flex, Row } from 'antd';
import { useTheme } from '@/contexts/themeContext';

interface StepperFormLayoutProps {
  children: React.ReactNode;
  handleSubmit: () => void;
  handleBackClick?: () => void;
  showBackButton: boolean;
  nextBtnText?: string;
  isSubmitLoading?: boolean;
  // New props for additional buttons
  showDraftButton?: boolean;
  handleSaveAsDraftClick?: () => void;
  isDraftLoading?: boolean;
}
const StepperFormLayout: FC<StepperFormLayoutProps> = ({
  children,
  handleSubmit,
  showBackButton,
  handleBackClick,
  nextBtnText = 'Next or Review',
  isSubmitLoading,
  handleSaveAsDraftClick,
  isDraftLoading,
}) => {
  const { sidebarCollapseState } = useTheme();
  return (
    <div
      style={{
        position: 'relative',
        // maxWidth: '1200px',
        margin: '0 auto',
        paddingBottom: '40px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* <div className="form-steps">steps</div> */}
      <div className="form-body" style={{ paddingBottom: '3.5rem' }}>
        {children}
      </div>
      <div
        className={`stepper-form-footer ${sidebarCollapseState ? 'sidebarContainerCollapse' : ''}`}
      >
        <Row>
          <Col xs={24}>
            <Flex
              justify={!showBackButton ? 'flex-end' : 'space-between'}
              gap={30}
            >
              {showBackButton && (
                <Button
                  size="large"
                  onClick={handleBackClick}
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '14px 24px',
                  }}
                >
                  Back
                </Button>
              )}

              {/* Right side: Group draft and submit buttons together */}
              <Flex gap={30}>
                {handleSaveAsDraftClick && (
                  <Button
                    size="large"
                    onClick={handleSaveAsDraftClick}
                    loading={isDraftLoading}
                    disabled={isDraftLoading}
                    style={{
                      fontSize: '14px',
                      fontWeight: '500',
                      padding: '14px 24px',
                    }}
                  >
                    Save As Draft
                  </Button>
                )}

                <Button
                  type="primary"
                  size="large"
                  onClick={handleSubmit}
                  loading={isSubmitLoading}
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '14px 24px',
                  }}
                >
                  {nextBtnText}
                </Button>
              </Flex>
            </Flex>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default StepperFormLayout;
